import type { ValueComparisonRow } from "~/componentsDS/ValueComparisonTable";

/** Forces a line break only on mobile (hidden from the `md` breakpoint up). */
const MobileBreak = () => <br className="md:hidden" />;

/** Common alternatives women combine to approximate BodyMatched® results. */
export const BODYMATCHED_ALTERNATIVES_COMPARISON_ROWS: ValueComparisonRow[] = [
    {
        label: { text: "Prescription tretinoin" },
        price: { text: "$60–$120", period: "/mo" },
    },
    {
        label: { text: "Estriol", note: "(prescription compounded)" },
        price: { text: "$60–$100", period: "/mo" },
    },
    {
        label: { text: "Niacinamide serum" },
        price: { text: "$30–$60", period: "/mo" },
    },
    {
        label: { text: "Oral progesterone", note: "(commonly layered on top)" },
        price: { text: "$30–$50", period: "/mo" },
    },
    {
        label: {
            text: (
                <>
                    Anti-facial-hair <MobileBreak />
                    treatments
                </>
            ),
            note: "(laser/electrolysis)",
        },
        price: { text: "$100–$300", period: "/mo", note: "(averaged over time)" },
    },
    {
        label: {
            text: (
                <>
                    Realistic combined <MobileBreak />
                    monthly cost
                </>
            ),
        },
        price: { text: "$250–$500", period: "/mo" },
        highlight: true,
    },
];

/** BodyMatched® all-in-one value compared with the combined alternatives. */
export const BODYMATCHED_TOTAL_VALUE_ROWS: ValueComparisonRow[] = [
    {
        label: { text: "Estimated Total Value" },
        price: { text: "$500/mo, or $12/day"}
    },
    {
        label: {
            text: (
                <>
                    Your Inner <MobileBreak />
                    Balance Price
                </>
            ),
        },
        price: { text: "$90/mo, or ~$3/day", note: "(for 3 month subscription)" },
        highlight: true,
        highlightClassName: "bg-secondary300",
    },
];

/** Standard prescriptions women are often given to replicate Oestra®. */
export const OESTRA_ALTERNATIVES_COMPARISON_ROWS: ValueComparisonRow[] = [
    {
        label: {
            text: (
                <>
                    Vaginal progesterone <MobileBreak />
                    (e.g., Crinone®)
                </>
            ),
        },
        price: { text: "$150–$220", period: "/mo" },
    },
    {
        label: {
            text: (
                <>
                    Vaginal estradiol <MobileBreak />
                    cream or tablet
                </>
            ),
        },
        price: { text: "$30–$60", period: "/mo" },
    },
    {
        label: {
            text: (
                <>
                    Separate estrogen patch or <MobileBreak />
                    oral estrogen (often still added)
                </>
            ),
        },
        price: { text: "$40–$80", period: "/mo" },
    },
    {
        label: {
            text: (
                <>
                    Oral progesterone <MobileBreak />
                    (commonly layered on)
                </>
            ),
        },
        price: { text: "$30–$50", period: "/mo" },
    },
    {
        label: {
            text: (
                <>
                    Follow-up visits <MobileBreak />
                    + dose adjustments
                </>
            ),
        },
        price: { text: "$50–$150", period: "/mo", note: "(averaged)" },
    },
    {
        label: {
            text: (
                <>
                    Realistic combined <MobileBreak />
                    monthly cost
                </>
            ),
        },
        price: { text: "$300–$450", period: "/mo" },
        highlight: true,
    },
];

/** Oestra® all-in-one value compared with the combined alternatives. */
export const OESTRA_TOTAL_VALUE_ROWS: ValueComparisonRow[] = [
    {
        label: { text: "Estimated Total Value" },
        price: { text: "$450", period: "/month" },
    },
    {
        label: {
            text: (
                <>
                    Your Inner <MobileBreak />
                    Balance Price
                </>
            ),
        },
        price: {
            text: (
                <>
                    $199/month <MobileBreak />
                    ($99.50 after first 6 months)
                </>
            ),
        },
        highlight: true,
        highlightClassName: "bg-secondary300",
    },
];
